import {Btn} from '../../../../ui-toolkit';
import {Table} from '../../../../ui-toolkit/indexExportV2';
import Paging from './Paging';
import React from 'react';
import styled from 'styled-components';

export function FooterRow({entitiesState, loadMore}) {
    if (!entitiesState.continuation) return null;
    return (
        <LoadBtnContainer>
            <Table.Row>
                <Table.Data colSpan={9999}>
                    <Paging
                        loadMore={loadMore}
                        totalCount={entitiesState.totalCount}
                        currentCount={entitiesState.entities.length}
                    />
                </Table.Data>
            </Table.Row>
        </LoadBtnContainer>
    );
}

const LoadBtnContainer = styled.tbody`
    ${Table.Data},
    ${Table.Row},
    ${Table.Data}:hover,
    ${Table.Row}:hover ${Table.Data} {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
        cursor: default;
    }

    ${Btn} {
        position: sticky;
        left: 0;
        padding: 6px 12px;
    }
`;
